module.exports = __webpack_public_path__ + "media/svg/logo-edukai-db51e426.svg";